import type { RequirementHistory } from '@routes/sidebar/admin-center/tenant-client/___pages___/matrices/api/matrices.api.ts';

export const REQUIREMENT_HISTORY_MOCK_DATA: RequirementHistory[] = [
    {
        id: 1,
        timestampUTC: '2024-12-01T08:15:00Z',
        action: 'ResettedDefault',
        reqID: 'LR.0.P.BB.0001',
        pathwayName: 'Methnol fire Safety',
        scopeSummary:
            'By vessel group | C/E, 2/E, 3/E, 4/E, ETO, E/C, FTR, OLR, WPR | Recommended | Since vessel assignment',
        performedBy: 'BB Admin',
    },
    {
        id: 2,
        timestampUTC: '2024-12-01T09:30:00Z',
        action: 'Published',
        reqID: 'LR.2.P.BB.0001',
        pathwayName: 'Methnol fire Safety',
        scopeSummary: 'By rank only | D/C | Mandatory | Since requirement start | Due 3D',
        performedBy: 'BB Admin',
    },
    {
        id: 3,
        timestampUTC: '2024-12-02T10:05:00Z',
        action: 'RePublished',
        reqID: 'LR.2.P.BB.0001',
        pathwayName: 'IISM Code Fundamentals and Practical Application',
        scopeSummary:
            'By vessel group | C/E, 2/E, 3/E, 4/E, ETO, E/C, FTR, OLR, WPR | Recommended | Since vessel assignment',
        performedBy: 'BB Admin',
    },
    {
        id: 4,
        timestampUTC: '2024-12-02T11:45:00Z',
        action: 'ResettedDefault',
        reqID: 'LR.2.P.BB.0001',
        pathwayName: 'IISM Code Fundamentals and Practical Application',
        scopeSummary: 'By rank only | D/C | Mandatory | Since requirement start | Due 3D',
        performedBy: 'BB Admin',
    },
    {
        id: 5,
        timestampUTC: '2024-12-03T08:20:00Z',
        action: 'ReActivated',
        reqID: 'LR.0.P.BB.0001',
        pathwayName: 'IISM Code Fundamentals and Practical Application',
        scopeSummary: 'By vessel group | D/C | Mandatory | Since vessel assignment | Due 14D',
        performedBy: 'BB Admin',
    },
    {
        id: 6,
        timestampUTC: '2024-12-03T09:50:00Z',
        action: 'Deleted',
        reqID: 'LR.2.P.BB.0001',
        pathwayName: 'Methnol fire Safety',
        scopeSummary: 'By vessel group | D/C | Mandatory | Since vessel assignment | Due 14D',
        performedBy: 'BB Admin',
    },
    {
        id: 7,
        timestampUTC: '2024-12-04T13:10:00Z',
        action: 'AutoDeactivated',
        reqID: 'LR.2.P.BB.0001',
        pathwayName: 'Methnol fire Safety',
        scopeSummary: 'By vessel group | D/C | Mandatory | Since vessel assignment | Due 14D',
        performedBy: 'BB Admin',
    },
    {
        id: 8,
        timestampUTC: '2024-12-04T14:40:00Z',
        action: 'Activated',
        reqID: 'LR.2.P.BB.0001',
        pathwayName: 'Methnol fire Safety',
        scopeSummary: 'By vessel group | D/C | Mandatory | Since vessel assignment | Due 14D',
        performedBy: 'BB Admin',
    },
    {
        id: 9,
        timestampUTC: '2024-12-05T09:00:00Z',
        action: 'Published',
        reqID: 'LR.0.P.BB.0001',
        pathwayName: 'IISM Code Fundamentals and Practical Application',
        scopeSummary:
            'By vessel group | MAS, C/O, 2/O, 3/O, D/C, BSN, AB, OS, C/E, 2/E, 3/E, 4/E, ETO, E/C, FTR, OLR, WPR, C/CK, STW, MSM | Recommended | Since vessel assignment',
        performedBy: 'BB Admin',
    },
    {
        id: 10,
        timestampUTC: '2024-12-05T10:30:00Z',
        action: 'Deactivated',
        reqID: 'LR.2.P.BB.0001',
        pathwayName: 'IISM Code Fundamentals and Practical Application',
        scopeSummary: 'By rank only | D/C | Mandatory | Since requirement start | Due 3D',
        performedBy: 'BB Admin',
    },
    {
        id: 11,
        timestampUTC: '2024-12-06T08:55:00Z',
        action: 'Activated',
        reqID: 'LR.2.P.BB.0001',
        pathwayName: 'IISM Code Fundamentals and Practical Application',
        scopeSummary:
            'By vessel group | MAS, C/O, 2/O, 3/O, D/C, BSN, AB, OS, C/E, 2/E, 3/E, 4/E, ETO, E/C, FTR, OLR, WPR, C/CK, STW, MSM | Recommended | Since vessel assignment',
        performedBy: 'BB Admin',
    },
    {
        id: 12,
        timestampUTC: '2024-12-06T11:15:00Z',
        action: 'Edited',
        reqID: 'LR.2.P.BB.0001',
        pathwayName: 'IISM Code Fundamentals and Practical Application',
        scopeSummary:
            'By vessel group | C/E, 2/E, 3/E, 4/E, ETO, E/C, FTR, OLR, WPR | Recommended | Since vessel assignment',
        performedBy: 'BB Admin',
    },
    {
        id: 13,
        timestampUTC: '2024-12-07T09:25:00Z',
        action: 'Deactivated',
        reqID: 'LR.0.P.BB.0001',
        pathwayName: 'Methnol fire Safety',
        scopeSummary:
            'By vessel group | C/E, 2/E, 3/E, 4/E, ETO, E/C, FTR, OLR, WPR | Recommended | Since vessel assignment',
        performedBy: 'BB Admin',
    },
    {
        id: 14,
        timestampUTC: '2024-12-07T10:50:00Z',
        action: 'Edited',
        reqID: 'LR.3.P.BB.0001',
        pathwayName: 'Methnol fire Safety',
        scopeSummary:
            'By vessel group | MAS, C/O, 2/O, 3/O, D/C, BSN, AB, OS, C/E, 2/E, 3/E, 4/E, ETO, E/C, FTR, OLR, WPR, C/CK, STW, MSM | Recommended | Since vessel assignment',
        performedBy: 'BB Admin',
    },
    {
        id: 15,
        timestampUTC: '2024-12-08T12:00:00Z',
        action: 'Deactivated',
        pathwayName: 'Methnol fire Safety',
        reqID: 'LR.2.P.BB.0001',
        scopeSummary: 'By vessel group | D/C | Mandatory | Since vessel assignment | Due 14D',
        performedBy: 'BB Admin',
    },
];
